import { put, call } from 'redux-saga/effects'
import { handleError, analyticsApiService } from 'Services/ApiService.js'
import AnalyticsActions from 'Stores/Analytics/Actions'
import { encodeObjectToBase64 } from '../Utils/base64functions'

export function* fetchOverview({ filter }) {
  yield put(AnalyticsActions.fetchOverviewLoading())

  if (filter != null) {
    filter = encodeObjectToBase64(filter)
  }
  try {
    const { data } = yield call(analyticsApiService.get, `/overview`, {
      params: {
        filter: filter,
      },
    })
    yield put(AnalyticsActions.fetchOverviewSuccess(data))
  } catch (e) {
    yield put(AnalyticsActions.fetchOverviewFail())
    handleError(e)
  }
}
export function* fetchAverageDuration({ filter }) {
  yield put(AnalyticsActions.fetchAverageDurationLoading())
  if (filter != null) {
    filter = encodeObjectToBase64(filter)
  }
  try {
    const { data } = yield call(analyticsApiService.get, `/averageDuration`, {
      params: {
        filter: filter,
      },
    })
    yield put(AnalyticsActions.fetchAverageDurationSuccess(data))
  } catch (e) {
    yield put(AnalyticsActions.fetchAverageDurationFail())
    handleError(e)
  }
}
export function* fetchTransactionsStatistics({}) {
  yield put(AnalyticsActions.fetchTransactionsStatisticsLoading())
  try {
    const { data } = yield call(
      analyticsApiService.get,
      `/transactionsStats`,
      {},
    )
    yield put(AnalyticsActions.fetchTransactionsStatisticsSuccess(data))
  } catch (e) {
    yield put(AnalyticsActions.fetchTransactionsStatisticsFail())
    handleError(e)
  }
}
export function* fetchConnectorsStatus({}) {
  yield put(AnalyticsActions.fetchConnectorsStatusLoading())
  try {
    const { data } = yield call(analyticsApiService.get, `/connectorStatus`, {})
    yield put(AnalyticsActions.fetchConnectorsStatusSuccess(data))
  } catch (e) {
    yield put(AnalyticsActions.fetchConnectorsStatusFail())
    handleError(e)
  }
}
export function* fetchPeakHour({ filter }) {
  yield put(AnalyticsActions.fetchPeakHourLoading())

  if (filter != null) {
    filter = encodeObjectToBase64(filter)
  }
  try {
    const { data } = yield call(analyticsApiService.get, `/peakHour`, {
      params: {
        filter: filter,
      },
    })
    yield put(AnalyticsActions.fetchPeakHourSuccess(data))
  } catch (e) {
    yield put(AnalyticsActions.fetchPeakHourFail())
    handleError(e)
  }
}

export function* fetchTopSites({ filter }) {
  yield put(AnalyticsActions.fetchTopSitesLoading())

  if (filter != null) {
    filter = encodeObjectToBase64(filter)
  }
  try {
    const { data } = yield call(analyticsApiService.get, `/topSites`, {
      params: {
        filter: filter,
      },
    })
    yield put(AnalyticsActions.fetchTopSitesSuccess(data))
  } catch (e) {
    yield put(AnalyticsActions.fetchTopSitesFail())
    handleError(e)
  }
}

export function* fetchTokensStatistics({ filter }) {
  yield put(AnalyticsActions.fetchTokensStatisticsLoading())

  if (filter != null) {
    filter = encodeObjectToBase64(filter)
  }
  try {
    const { data } = yield call(analyticsApiService.get, `/tokensStats`, {
      params: {
        filter: filter,
      },
    })
    yield put(AnalyticsActions.fetchTokensStatisticsSuccess(data))
  } catch (e) {
    yield put(AnalyticsActions.fetchTokensStatisticsFail())
    handleError(e)
  }
}

export function* fetchRevenueTrend({ filter }) {
  yield put(AnalyticsActions.fetchRevenueTrendLoading())

  if (filter != null) {
    filter = encodeObjectToBase64(filter)
  }
  try {
    const { data } = yield call(analyticsApiService.get, `/revenueTrend`, {
      params: {
        filter: filter,
      },
    })
    yield put(AnalyticsActions.fetchRevenueTrendSuccess(data))
  } catch (e) {
    yield put(AnalyticsActions.fetchRevenueTrendFail())
    handleError(e)
  }
}

export function* fetchTokensActivity({}) {
  yield put(AnalyticsActions.fetchTokensActivityLoading())
  try {
    const { data } = yield call(analyticsApiService.get, `/tokensActivity`, {})
    yield put(AnalyticsActions.fetchTokensActivitySuccess(data))
  } catch (e) {
    yield put(AnalyticsActions.fetchTokensActivityFail())
    handleError(e)
  }
}

export function* fetchTopCities({ filter }) {
  yield put(AnalyticsActions.fetchTopCitiesLoading())
  if (filter != null) {
    filter = encodeObjectToBase64(filter)
  }
  try {
    const { data } = yield call(analyticsApiService.get, `/topCities`, {
      params: {
        filter: filter,
      },
    })
    yield put(AnalyticsActions.fetchTopCitiesSuccess(data))
  } catch (e) {
    yield put(AnalyticsActions.fetchTopCitiesFail())
    handleError(e)
  }
}
